import { mapRoot } from "../config";
import {camelize} from "./cases";

const getDataFromCMS = (dataName:string) => {
  const dom = document.getElementById(mapRoot)
  if (!dom) return false
  let s3

  s3 = dataName

  if (dataName.startsWith('data-')) {
    const s2 = dataName.indexOf("-");
    s3 = s2 === -1 ? dataName : dataName.substring(s2);
  }
  return dom.dataset[camelize(s3)]
}

export default getDataFromCMS
